import _findIndex from 'lodash/findIndex';

export function setEmailChange(state, changesKey, trigger, comparisonKey) {
  const triggerIndex = _findIndex(state[changesKey], (o) => { 
    return o[comparisonKey] === trigger[comparisonKey];
  });

  if (triggerIndex >= 0) {
    // Remove old value
    state[changesKey].splice(triggerIndex, 1);
  }

  state[changesKey].push(trigger);
}

export function resetEmailChanges(state, changesKey) {
  state[changesKey] = [];
}

// export function consolidateEventChanges(state, changesKey, emailsKey, properties, comparisonKey) {
//   const numChanges = state[changesKey].length;
//   const numParentEmails = state[emailsKey].length;

//   for (let i = 0; i < numChanges; i++) {
//     const change = state[changesKey][i];

//     /* Iterate through Calendar Event Emails */
//     for (let parent = 0; parent < numParentEmails; parent++) {
//       const parentEmail = state[emailsKey][parent];
//       if (parentEmail[comparisonKey] === change[comparisonKey]) {
//         properties.forEach(property => {
//           state[emailsKey][parent][property] = change[property];
//         });
//       }
      
//       /* Iterate through Additional Email Triggers */
//       const numTriggers = state[emailsKey][parent].additional_triggers.length;
//       for (let child = 0; child < numTriggers; child++) {
//         const childEmail = state[emailsKey][parent].additional_triggers[child];
//         if (childEmail[comparisonKey] === change[comparisonKey]) {
//           properties.forEach(property => {
//             state[emailsKey][parent].additional_triggers[child][property] = change[property];
//           });
//         }
//       }
//     }
//   }
// }


/* Change Events */
export function updateEmailTemplate(state, emailsKey, updatedTemplate, triggerId) {
  let isAdditionalTrigger = false;
  let foundTrigger = false;
  let indexOne = 0;
  let indexTwo = 0;
  for (let parentTrigger of state[emailsKey]) {
    if (parentTrigger.id == triggerId) {
      foundTrigger = true;
      break;
    }
    indexTwo = 0;
    for (let additionalTrigger of parentTrigger.additional_triggers) {
      if (additionalTrigger.id == triggerId) {
        foundTrigger = true;
        isAdditionalTrigger = true;
        break;
      }
      indexTwo++;
    }
    if (foundTrigger) { break; }
    indexOne++;
  }
  if (foundTrigger) {
    if (isAdditionalTrigger) {
      state[emailsKey][indexOne].additional_triggers[indexTwo].email = updatedTemplate;
    } else {
      state[emailsKey][indexOne].email = updatedTemplate;
    }
  }
}


export function addEmailTrigger(state, emailsKey, newTrigger, originalTriggerId) {
  const triggerIndex = _findIndex(state[emailsKey], (o) => {
    return o.id === originalTriggerId;
  });

  if (triggerIndex >= 0) {
    state[emailsKey][triggerIndex].additional_triggers.push(newTrigger);
  }
}

export function deleteEmailTrigger(state, emailsKey, originalTriggerId, deleteTriggerId) {
  const originalTriggerIndex = _findIndex(state[emailsKey], (o) => {
    return o.id === originalTriggerId;
  });

  if (originalTriggerIndex >= 0) {
    const deleteTriggerIndex = _findIndex(state[emailsKey][originalTriggerIndex].additional_triggers, (o) => {
      return o.id === deleteTriggerId;
    });

    state[emailsKey][originalTriggerIndex].additional_triggers.splice(deleteTriggerIndex, 1);
  }
}

// export function deleteEmailTrigger(state, deleteTriggerId, originalTrigggerId) {
//   const originalTriggerIndex = _findIndex(state.calendarEventEmails, (elem) => elem.id === originalTrigggerId);
//   if (originalTriggerIndex >= 0) {
//     const deleteTriggerIndex = _findIndex(
//       state.calendarEventEmails[originalTriggerIndex].additional_triggers, 
//       (elem) => elem.id === deleteTriggerId
//     );
//     state.calendarEventEmails[originalTriggerIndex].additional_triggers.splice(
//       deleteTriggerIndex,
//       1
//     );
//   }
// }

/* OLD CODE */
// setCalendarEventEmailChange(state, calendarEventTrigger) {
//   const triggerIndex = _findIndex(state.calendarEventEmailChanges, function(o) { 
//     return o.id === calendarEventTrigger.id;
//   });

//   if (triggerIndex >= 0) {
//     // Remove old value
//     state.calendarEventEmailChanges.splice(triggerIndex, 1);
//   }

//   state.calendarEventEmailChanges.push(calendarEventTrigger);
// },
// resetCalendarEventEmailChanges(state) {
//   state.calendarEventEmailChanges = [];
// },
// consolidateCalendarEventChanges(state) {
//   const numChanges = state.calendarEventEmailChanges.length;
//   const numParentEmails = state.calendarEventEmails.length;

//   for (let i = 0; i < numChanges; i++) {
//     const change = state.calendarEventEmailChanges[i];

//     /* Iterate through Calendar Event Emails */
//     for (let parent = 0; parent < numParentEmails; parent++) {
//       const parentEmail = state.calendarEventEmails[parent];
//       if (parentEmail.id === change.id) {
//         state.calendarEventEmails[parent].active = change.active;
//         state.calendarEventEmails[parent].days_out = change.days_out;
//       }
      
//       /* Iterate through Additional Email Triggers */
//       const numTriggers = state.calendarEventEmails[parent].additional_triggers.length;
//       for (let child = 0; child < numTriggers; child++) {
//         const childEmail = state.calendarEventEmails[parent].additional_triggers[child];
//         if (childEmail.id === change.id) {
//           state.calendarEventEmails[parent].additional_triggers[child].active = change.active;
//           state.calendarEventEmails[parent].additional_triggers[child].days_out = change.days_out;
//         }
//       }
//     }
//   }
// }

export default {
  setEmailChange,
  resetEmailChanges,
  addEmailTrigger,
  deleteEmailTrigger,
  updateEmailTemplate,
};
